module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNLTEuMDU1MjllLTA3IDEwLjU4NThDLTYuNjU4NTllLTA4IDExLjQ3NjcgMS4wNzcxNCAxMS45MjI5IDEuNzA3MTEgMTEuMjkyOUw2LjI5Mjg5IDYuNzA3MTFDNi42ODM0MiA2LjMxNjU4IDYuNjgzNDIgNS42ODM0MiA2LjI5Mjg5IDUuMjkyODlMMS43MDcxIDAuNzA3MTA1QzEuMDc3MTQgMC4wNzcxNDAzIC01LjQ1MzczZS0wNyAwLjUyMzMwOSAtNS4wNjQzMWUtMDcgMS40MTQyMUwtMS4wNTUyOWUtMDcgMTAuNTg1OFoiIGZpbGw9IiM3Nzc4NzkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/turningdown.svg
// module id = 2J23
// module chunks = 1